// Razorpay helper — loads Checkout.js if it isn't already on the page,
// then opens the modal with the order details returned by the backend.
const RAZORPAY_SRC = "https://checkout.razorpay.com/v1/checkout.js";

export const loadRazorpay = () =>
    new Promise((resolve) => {
        if (typeof window === "undefined") return resolve(false);
        if (window.Razorpay) return resolve(true);
        const existing = document.querySelector(`script[src="${RAZORPAY_SRC}"]`);
        if (existing) {
            existing.addEventListener("load", () => resolve(true));
            existing.addEventListener("error", () => resolve(false));
            return;
        }
        const script = document.createElement("script");
        script.src = RAZORPAY_SRC;
        script.async = true;
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
